import { Tabs } from 'src/design/molecules/Tabs';
import React from 'react';
import { useJobs } from 'src/hooks/useJobs';
import { Header } from 'src/design/organisms/Header';
import { ActivityFeedView } from './ActivityFeedView';
import { JobByUserActivity } from './JobByUserActivity';

export const ActivityFeed: React.FC = () => {
  const { selectedJob } = useJobs();

  return (
    <>
      <Header
        title="Activity Feed"
        breadcrumbProps={{
          items: [
            { text: 'Jobs', href: '/jobs' },
            {
              text: `${selectedJob?.name} - ${selectedJob?.jobNumber}`,
              href: `/jobs/${selectedJob?.id}/summary`,
            },
            { text: 'Activity Feed' },
          ],
        }}
        helpText="View activity by job or by user"
      />

      <Tabs defaultValue="by-job" mt="md">
        <Tabs.List justify="center">
          <Tabs.Tab value="by-job">By Job</Tabs.Tab>
          <Tabs.Tab value="by-user">By User</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="by-job">
          <ActivityFeedView />
        </Tabs.Panel>

        <Tabs.Panel value="by-user">
          {selectedJob && <JobByUserActivity jobId={selectedJob.id} />}
        </Tabs.Panel>
      </Tabs>
    </>
  );
};
